export default __webpack_public_path__ + "static/media/OPS-Tracker-Logo.cd9de027.png";